"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removePostLock = exports.refreshPostLock = exports.reorderPosts = exports.duplicatePost = exports.emptyTrash = exports.deletePost = exports.updatePost = exports.getPost = exports.addPost = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _services = require("../services");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var addPost = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _services.postServices.addPost(args, dispatch, config);

          case 2:
            result = _context.sent;

            if (result) {
              dispatch({
                type: "ADD_POST",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: args.siteID
                })
              });
            }

            return _context.abrupt("return", result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addPost(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

exports.addPost = addPost;

var getPost = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _services.postServices.getPost(args, dispatch, config);

          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPost(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getPost = getPost;

var updatePost = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _services.postServices.updatePost(args, dispatch, config);

          case 2:
            result = _context3.sent;

            if (result) {
              dispatch({
                type: "ADD_POST",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: args.siteID
                })
              });
              dispatch({
                type: "ADD_EDITOR_POST",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: args.siteID
                })
              });
            }

            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updatePost(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

exports.updatePost = updatePost;

var deletePost = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            siteID = _ref.siteID, id = _ref.id;
            _context4.next = 3;
            return _services.postServices.deletePost({
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context4.sent;

            if (result) {
              dispatch({
                type: "DELETE_POST",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: siteID
                })
              });
            }

            return _context4.abrupt("return", result);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deletePost(_x10, _x11, _x12) {
    return _ref7.apply(this, arguments);
  };
}();

exports.deletePost = deletePost;

var emptyTrash = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _services.postServices.emptyTrash(args, dispatch, config);

          case 2:
            result = _context5.sent;

            if (result) {
              dispatch({
                type: "DELETE_POSTS",
                payload: {
                  posts: result,
                  siteID: args.siteID
                }
              });
            }

            return _context5.abrupt("return", result);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function emptyTrash(_x13, _x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();

exports.emptyTrash = emptyTrash;

var duplicatePost = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref2, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            siteID = _ref2.siteID, id = _ref2.id;
            _context6.next = 3;
            return _services.postServices.duplicatePost({
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context6.sent;

            if (result) {
              dispatch({
                type: "ADD_POST",
                payload: _objectSpread(_objectSpread({}, result), {}, {
                  siteID: siteID
                })
              });
            }

            return _context6.abrupt("return", result);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function duplicatePost(_x16, _x17, _x18) {
    return _ref9.apply(this, arguments);
  };
}();

exports.duplicatePost = duplicatePost;

var reorderPosts = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref3, dispatch, config) {
    var siteID, postType, posts, postIDs;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            siteID = _ref3.siteID, postType = _ref3.postType, posts = _ref3.posts;
            postIDs = posts.reduce(function (ac, a) {
              return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a.order));
            }, {}); // We're not gonna wait until the function is completed to give the user an instant feedback

            _services.postServices.reorderPosts({
              siteID: siteID,
              postIDs: postIDs
            }, dispatch, config);

            dispatch({
              type: 'UPDATE_COLLECTION',
              payload: _objectSpread(_objectSpread({
                siteID: siteID
              }, postType), {}, {
                posts: posts.reduce(function (ac, a) {
                  return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a));
                }, {})
              })
            });

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function reorderPosts(_x19, _x20, _x21) {
    return _ref10.apply(this, arguments);
  };
}();

exports.reorderPosts = reorderPosts;

var refreshPostLock = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _services.postServices.refreshPostLock(args, dispatch, config);

          case 2:
            result = _context8.sent;
            return _context8.abrupt("return", result);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function refreshPostLock(_x22, _x23, _x24) {
    return _ref11.apply(this, arguments);
  };
}();

exports.refreshPostLock = refreshPostLock;

var removePostLock = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _services.postServices.removePostLock(args, dispatch, config);

          case 2:
            result = _context9.sent;
            return _context9.abrupt("return", result);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function removePostLock(_x25, _x26, _x27) {
    return _ref12.apply(this, arguments);
  };
}();

exports.removePostLock = removePostLock;